// extracted by mini-css-extract-plugin
export var root = "styles-module--root--fZKP+";
export var main = "styles-module--main--HQtj+";